<template>
<div class="com-more-button">
  <!-- 加载没有更多了 -->
  <span v-if="end" class="finish-label">{{finishLabel}}</span>
  <!-- 如果有数据的话继续加载 -->
  <template v-else>
    <!-- 加载中转圈圈～ -->
    <gkLoading color="blue" v-if="loading" />
    <!-- gkButton -->
    <gkButton
      class="more-button"
      color="more"
      :label="btnLabel"
      :use-lock="true"
      @click="handleMore"
      v-if="!loading && loadingCount >= 3"
    />
  </template>
</div>
</template>

<script>
import { mapMutations } from 'vuex'
import VueTypes from 'vue-types'
import gkLoading from 'gkui/loading'
import gkButton from 'gkui/button'

/**
 * 加载更多按钮
 * @desc 如果已全部加载(end=true)则显示相关文案([finishLabel="没有更多了"])
 *       加载时显示 gkLoading
 *       加载次数(loadingCount) 达到 3 次之后显示加载按钮
 * @module component/MoreButton
 * @extends gkButton
 * @example
 * <MoreButton :loading="loading" :end="end" :loadingCount="loadingCount" @click="handleClick" />
 */
export default {
  name: 'more-button',
  components: {
    gkLoading,
    gkButton
  },
  /**
   * 传入数据
   * @prop {String}  [size=small]              按钮 size
   * @prop {Boolean} [loading=false]           是否正在加载
   * @prop {Number}  [loadingCount=0]          已加载的次数
   * @prop {Boolean} [end=false]               列表是否已到末尾
   * @prop {String}  [btnLabel=加载更多]        加载按钮文案
   * @prop {String}  [finishLabel=没有更多了]   全部加载后显示的文案
   */
  props: {
    size: VueTypes.string.def('small'),
    loading: VueTypes.bool.def(false),
    loadingCount: VueTypes.number.def(0),
    end: VueTypes.bool.def(false),
    btnLabel: VueTypes.string.def('加载更多'),
    finishLabel: VueTypes.string.def('没有更多了')
  },
  methods: {
    ...mapMutations({
      setBottom: 'CHECK_BOTTOM'
    }),
    handleMore ($event) {
      // 加载更多时候 footer 已经不是在底部了 重置isBottom 状态 在 Home 组件中调整侧边栏定位
      this.setBottom(false)
      this.$emit('click', $event)
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '../../assets/css/common';

.com-more-button {
  // @extend %center;
  // flex-direction: column;
  display: flex;
  justify-content: center;
  min-height: 24px;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  color: #353535;

  & .finish-label {
    // color: $gray;
  }

  & .more-button {
    margin: 20px auto;
    width: 175px; height: 38px;
    border-radius: 4px;

    &[gkbtn-color=more] {
      background: #F8F9FA;
      // color: $gray;
      border-color: #F8F9FA;
      box-shadow: 0 0 0 1px #F8F9FA;

      &:hover {
        color: #353535;
      }
    }
  }
}
</style>
